import { render, staticRenderFns } from "./calendar.vue?vue&type=template&id=59c19fc2&scoped=true&"
import script from "./calendar.vue?vue&type=script&lang=js&"
export * from "./calendar.vue?vue&type=script&lang=js&"
import style0 from "./calendar.vue?vue&type=style&index=0&id=59c19fc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c19fc2",
  null
  
)

export default component.exports